import React, {
    Fragment,
    useEffect,
    useState,
    useCallback,
    forwardRef,
    useRef,
    useImperativeHandle
} from "react";
import Select from "react-select";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import uuid from "uuid";
import moment from "moment";

import MaterialDateTimePicker from "../global/form/MaterialDateTimePicker";
import Spinner from "../global/Spinner";
import ImagesHorizontal from "../global/image/ImagesHorizontal";
import {
    getUnapprovedPromoDraft,
    rejectUnapprovedPromo,
    updateUnapprovedPromo
} from "../../actions/admin/unapproved_promo";
import { getOfferOptions } from "../../actions/admin/offer_option";
import { getCategories } from "../../actions/admin/category";

const FormCreate = forwardRef(
    (
        {
            getUnapprovedPromoDraft,
            rejectUnapprovedPromo,
            updateUnapprovedPromo,
            getOfferOptions,
            unapproved_promo: { loading, remainPromo },
            getCategories
        },
        ref
    ) => {
        const selectCategoryRef = useRef();
        const titleRef = useRef();

        useImperativeHandle(ref, () => ({
            onRejectPromo() {
                rejectPromo();
            }
        }));

        const [categoryOptions, setCategoryOptions] = useState([]);

        const [selectedCategoryOptions, setSelectedCategoryOptions] = useState(
            []
        );

        const [objectOfferOptions, setObjectOfferOptions] = useState([]);

        const [arrayOfferOptions, setArrayOfferOptions] = useState([]);

        const [selectedOfferOption, setSelectedOfferOption] = useState(null);

        const [inputValues, setInputValues] = useState(null);

        const [formData, setFormData] = useState({
            continue: true,
            id: "",
            title: "",
            description: "",
            source: "",
            postDate: "",
            images: [],
            dateFrom: new Date(moment().startOf("day")),
            dateTill: new Date(moment().startOf("day")),
            offerOptionId: "",
            categoryIds: []
        });

        const {
            id,
            title,
            description,
            source,
            postDate,
            images,
            dateFrom,
            dateTill,
            offerOptionId
        } = formData;

        const renderOfferOptions = Object.keys(objectOfferOptions).map(key => {
            return (
                <Fragment key={uuid.v4()}>
                    <option value={key} key={uuid.v4()} disabled>
                        {key}
                    </option>
                    {objectOfferOptions[key].map(option => {
                        let content = "";
                        option.content.forEach(item => {
                            if (item.text !== "") {
                                content += item.text;
                            } else {
                                content += "___";
                            }
                        });
                        return (
                            <option value={option.id} key={uuid.v4()}>
                                {content}
                            </option>
                        );
                    })}
                </Fragment>
            );
        });

        const renderInput =
            selectedOfferOption !== null ? (
                selectedOfferOption.content.map((item, index) => {
                    if (item.isHint === false) {
                        if (item.isInput === false) {
                            return (
                                <Fragment key={index}>
                                    {" " + item.text + " "}
                                </Fragment>
                            );
                        } else {
                            return (
                                <Fragment key={index}>
                                    <input
                                        type="text"
                                        value={
                                            inputValues["titleInput" + index]
                                        }
                                        name={"titleInput" + index}
                                        onChange={e => onChangeTitleInput(e)}
                                        required
                                        style={{ width: "80px" }}
                                    />
                                </Fragment>
                            );
                        }
                    }

                    return <Fragment key={index}></Fragment>;
                })
            ) : (
                <Fragment></Fragment>
            );

        const renderTitle =
            selectedOfferOption !== null ? (
                selectedOfferOption.content.map((item, index) => {
                    if (item.isHint === false) {
                        if (item.isInput === false) {
                            return <Fragment key={index}>{item.text}</Fragment>;
                        } else {
                            return (
                                <Fragment key={index}>
                                    {inputValues["titleInput" + index]}
                                </Fragment>
                            );
                        }
                    }

                    return <Fragment key={index}></Fragment>;
                })
            ) : (
                <Fragment>{title}</Fragment>
            );

        useEffect(() => {
            const fetchCategoriesData = async () => {
                const categories = await getCategories();
                const categoryOptions = categories.map(category => {
                    return {
                        value: category.id,
                        label: category.name
                    };
                });
                setCategoryOptions(categoryOptions);
            };

            fetchCategoriesData();
        }, [getCategories]);

        const fetchDraftData = useCallback(async () => {
            const promo = await getUnapprovedPromoDraft();
            if (promo) {
                // TODO: Get categories of the source and set them for the unapproved promo.
                setFormData({
                    id: promo.id,
                    description: promo.description,
                    source: promo.source,
                    postDate: promo.sourcePromoPostDate,
                    dateFrom: new Date(moment().startOf("day")),
                    dateTill: new Date(moment().startOf("day")),
                    images:
                        promo.promoImages && promo.promoImages.length
                            ? promo.promoImages.map(image => {
                                  return {
                                      source: image
                                  };
                              })
                            : [],
                    categoryIds: []
                });
            }

            setSelectedCategoryOptions([]);
        }, [getUnapprovedPromoDraft]);

        useEffect(() => {
            fetchDraftData();
        }, [fetchDraftData]);

        useEffect(() => {
            const fetchOfferOptions = async () => {
                const offerOptions = await getOfferOptions();
                setArrayOfferOptions(offerOptions);
                const convertOfferOptions = _.groupBy(offerOptions, function(
                    option
                ) {
                    return option.group;
                });
                setObjectOfferOptions(convertOfferOptions);
            };

            fetchOfferOptions();
        }, [getOfferOptions]);

        const handleChangeCategoryOptions = selectedOption => {
            setSelectedCategoryOptions(selectedOption);
            var catInput = _.map(selectedOption, "value");
            if (!(catInput instanceof Array)) {
                selectedOption = [selectedOption];
            } else {
            }
            setFormData({
                ...formData,
                categoryIds: _.map(selectedOption, "value")
            });
        };

        const getSelectedCategoryOptionsValue = () => {
            if (selectedCategoryOptions && selectedCategoryOptions.length)
                return selectedCategoryOptions.length;
            else return "";
        };

        const onChange = e => {
            setFormData({ ...formData, [e.target.name]: e.target.value });

            if (e.target.name === "offerOptionId") {
                if (e.target.value !== "") {
                    const selectedOfferOption = _.find(arrayOfferOptions, [
                        "id",
                        parseInt(e.target.value)
                    ]);
                    setSelectedOfferOption(selectedOfferOption);
                    let inputValues = [];
                    selectedOfferOption.content.forEach((item, index) => {
                        if (item.isInput === true) {
                            inputValues["titleInput" + index] = "";
                        }
                    });
                    setInputValues(inputValues);
                } else {
                    setSelectedOfferOption(null);
                }
            }
        };

        const onChangeTitleInput = e => {
            setInputValues({
                ...inputValues,
                [e.target.name]: e.target.value
            });
        };

        const onSubmit = async e => {
            e.preventDefault();
            const approvePromoResponse = await updateUnapprovedPromo(
                {
                    ...formData,
                    title: titleRef.current.innerText
                },
                id
            );
            if (approvePromoResponse) {
                fetchDraftData();
                setSelectedOfferOption(null);
            }
        };

        const rejectPromo = async () => {
            const rejectPromoResponse = await rejectUnapprovedPromo(id);
            if (rejectPromoResponse) {
                fetchDraftData();
                setSelectedOfferOption(null);
            }
        };

        return loading ? (
            <Spinner />
        ) : !remainPromo ? (
            <Fragment>
                There is no unapproved promotion.{" "}
                <Link to="/admin/unapproved-promo">
                    <button className="btn btn-secondary">Back</button>
                </Link>
            </Fragment>
        ) : (
            <form
                className="form"
                onSubmit={e => onSubmit(e)}
                autoComplete="off"
            >
                <div className="form-group">
                    {/* <label className="col-form-label">Images</label> */}
                    {images && images.length ? (
                        <ImagesHorizontal images={images}></ImagesHorizontal>
                    ) : (
                        <Fragment>
                            <label className="h2">No Images</label>
                        </Fragment>
                    )}
                </div>
                <div className="form-group mt-3 mb-4">{description}</div>
                <hr className="mb-4" />
                <div className="form-group mb-4">
                    <div className="d-flex align-items-center">
                        {/* <div>
                            Promo from <Link to="#">{source}</Link>, available
                            in <Link to="#">All</Link> outlets{" "}
                        </div> */}
                        {/* <button
                            className="btn btn-primary ml-1"
                            onClick={e => {
                                e.preventDefault();
                            }}
                            style={{ minWidth: "110px" }}
                        >
                            Select outlets
                        </button> */}
                        <div>
                            Promo from:{" "}
                            <span style={{ fontWeight: "bold" }}>{source}</span>
                        </div>
                    </div>
                </div>
                <div className="form-group mb-4">
                    <div>
                        Post date:{" "}
                        <span style={{ fontWeight: "bold" }}>{postDate}</span>
                    </div>
                </div>
                <div className="form-group mb-4">
                    <label className="col-form-label">Category *</label>
                    <Select
                        value={selectedCategoryOptions}
                        onChange={handleChangeCategoryOptions}
                        options={categoryOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        blurInputOnSelect={false}
                        ref={selectCategoryRef}
                        styles={{
                            container: (base, state) => {
                                return {
                                    ...base,
                                    zIndex: state.isFocused ? "999" : "1" //Only when current state focused
                                };
                            }
                        }}
                    />
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{
                            opacity: 0,
                            width: "100%",
                            height: 0,
                            position: "absolute"
                        }}
                        value={getSelectedCategoryOptionsValue()}
                        onChange={e => {
                            e.preventDefault();
                        }}
                        onFocus={() => selectCategoryRef.current.focus()}
                        required
                    />
                </div>
                <div className="form-group mb-4">
                    <div className="input-group mb-2">
                        <div className="input-group-prepend">
                            <div className="input-group-text">Options</div>
                        </div>
                        <select
                            className="form-control"
                            name="offerOptionId"
                            value={offerOptionId}
                            onChange={e => onChange(e)}
                            required
                        >
                            <option value="">Select a option</option>
                            {renderOfferOptions}
                        </select>
                    </div>
                </div>
                <div className="form-group mb-4">Input: {renderInput}</div>
                <div className="form-group mb-4">
                    Title:{" "}
                    <span className="text-primary" ref={titleRef}>
                        {renderTitle}
                    </span>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="form-group">
                            <label className="col-form-label">
                                Start Date:{" "}

                                <Moment
                                    format="DD-MM-YYYY HH:mm"
                                    className="text-primary hide-on-mobile"
                                >
                                    {dateFrom}
                                </Moment>
                            </label>
                            <div className="static-material-datetime-picker">
                                <MaterialDateTimePicker
                                    value={dateFrom}
                                    onChange={dateFrom =>
                                        setFormData({ ...formData, dateFrom })
                                    }
                                    variant="static"
                                />
                            </div>
                            <div className="show-on-mobile">
                                <MaterialDateTimePicker
                                    value={dateFrom}
                                    onChange={dateFrom =>
                                        setFormData({ ...formData, dateFrom })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="form-group">
                            <label className="col-form-label">
                                End Date:{" "}
                                <Moment
                                    format="DD-MM-YYYY HH:mm"
                                    className="text-primary hide-on-mobile"
                                >
                                    {dateTill}
                                </Moment>
                            </label>
                            <div className="static-material-datetime-picker">
                                <MaterialDateTimePicker
                                    value={dateTill}
                                    onChange={dateTill =>
                                        setFormData({ ...formData, dateTill })
                                    }
                                    variant="static"
                                />
                            </div>
                            <div className="show-on-mobile">
                                <MaterialDateTimePicker
                                    value={dateTill}
                                    onChange={dateTill =>
                                        setFormData({ ...formData, dateTill })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <input
                        type="submit"
                        className="btn btn-primary float-right mr-1"
                        value="Accept"
                    />
                </div>
            </form>
        );
    }
);

FormCreate.propTypes = {
    unapproved_promo: PropTypes.object.isRequired,
    getUnapprovedPromoDraft: PropTypes.func.isRequired,
    rejectUnapprovedPromo: PropTypes.func.isRequired,
    updateUnapprovedPromo: PropTypes.func.isRequired,
    getOfferOptions: PropTypes.func.isRequired,
    getCategories: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    unapproved_promo: state.admin.unapproved_promo
});

export default connect(
    mapStateToProps,
    {
        getUnapprovedPromoDraft,
        rejectUnapprovedPromo,
        updateUnapprovedPromo,
        getOfferOptions,
        getCategories
    },
    null,
    {
        forwardRef: true
    }
)(FormCreate);
